/*
 * @Author: your name
 * @Date: 2020-04-22 14:40:14
 * @LastEditTime: 2023-03-16 10:25:50
 * @LastEditors: fangteng fangteng@yaomaitong.cn
 * @Description: In User Settings Edit
 * @FilePath: /ksh-doctor/src/service/IndexService.js
 */
import request from '@/utils/request'
import {API} from './apiConfig'

export function getIndexBanner(showArea='') {
	return request({
		url: API.IndexBanner,
		method: 'get',
		params: {
			showArea
		},
	})
}
export function checkMiniGuide(confirm=false) {
	return request({
		url: API.checkMiniGuide,
		method: 'get',
		params: {
			confirm
		},
	})
}
export function checkWechat() {
	return request({
		url: API.checkWechat,
		method: 'get',
	})
}
export function getIndexMeetingList(pageNo=1,pageSize=10,oldOrNew='new',status = ''){
	return request({
		url: API.IndexMeetingList,
		method: 'get',
		params: {
			status,
			pageNo,
			pageSize,
			oldOrNew
		},
	})
}
export function getIndexSurveyList(pageNo=1,pageSize=10,status=''){
	return request({
		url: API.IndexSurveyList,
		method: 'get',
		params: {
			status,
			pageNo,
			pageSize
		},
	})
}
export function getIndexVisitList(pageNo=1,pageSize=10,status=''){
	return request({
		url: API.IndexVisitList,
		method: 'get',
		params: {
			status,
			pageNo,
			pageSize
		},
	})
}
export function getNewVisitList(pageNo = 1, pageSize = 10,status = '') {
	return request({
		url: API.getNewVisitList,
		method: 'get',
		params: {
			pageNo,
			pageSize,
			status
		},
	})
}
export function getIndexQuestionnaireList({pageNo=1,pageSize=10,status='', subType = 1}){
	return request({
		url: API.IndexQuestionnaireList,
		method: 'get',
		params: {
			status,
			pageNo,
			pageSize,
			subType
		},
	})
}
export function inviteCount() {
	return request({
		url: API.inviteCount,
		method: 'get',
	})
}
export function getSceneCode(data) {
	return request({
		url: API.getSceneCode,
		method: 'get',
		params:data
	})
}
